import React, { useCallback, useLayoutEffect } from 'react';
import IconEyes from 'design-system/icons/IconEyes';
import { IconBell, IconShieldDone } from 'design-system/icons';
import FeatureIntroduction from 'design-system/FeatureIntroduction';
import useColors from 'hooks/useColors';
const strings = {
    title: 'Fraud detection',
    subTitle: 'Let Emma protect your online identity',
};
const FRAUD_DETECTION_ITEMS = [
    {
        icon: <IconEyes gradientKey="pro"/>,
        title: 'Scan the dark web',
        description: 'Let Emma scan the dark web and identify if your personal details have been hacked from other services',
    },
    {
        icon: <IconBell gradientKey="lightPink"/>,
        title: 'Receive alerts',
        description: 'Receive fraud alerts when new leaks are identified and take action',
    },
    {
        icon: <IconShieldDone gradientKey="darkPurple"/>,
        title: 'Gain control over your privacy',
        description: 'Control and monitor your privacy and your personal information',
    },
];
const FraudProtectionIntro = ({ navigation, }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Fraud detection',
            headerTitle: '',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const onPressNext = useCallback(() => {
        navigation.navigateDeprecated('DataProtectionSettings', {
            isCreateFlow: true,
        });
    }, []);
    return (<FeatureIntroduction title={strings.title} subTitle={strings.subTitle} items={FRAUD_DETECTION_ITEMS} buttonText="Continue" onPressNext={onPressNext} topIcon={<IconShieldDone colorKey="statusPositive"/>}/>);
};
export default FraudProtectionIntro;
